import React, { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import { BlogLength } from "./Blog/BlogApi";
import { CaseStudiesLength } from "./CaseStudy/CaseApi";
import { CareerLength } from "./Career/CareerApi";
import { EventLength } from "./Events/EventApi";
import { AwardLength } from "./Award/AwardApi";
import { TestiLength } from "./Testimonials/TestiApi";
import { UrlLength } from "./RedirectUrl/UrlApi";
import { VideoLength } from "./TestiVideo/TestiVideoApi";
import { VideosLength } from "./Videos/VideosApi";
import { EbookLength } from "./Ebooks/EbookApi";
import { PageVideoLength } from "./PageVIdeo/PageVideoApi";
import { FaqsLength } from "./Faq/FaqsApi";
import { GlossaryLength } from "./Glossary/GlossaryApi";
import { WebinarLength } from "./webinar/WebinarApi";
import { AdsLength } from "./Ads/AdsApi";

import { MetaTagLength } from "./MetaTag/MetaTagApi";
import { ViewModels } from "./SidebarFormat";
import { InterestedproductLength } from "./InterestedproductApi.js/ProductAPi";
import { EmailLength } from "./Email/EmailApi";
import { LeadLength } from "./Leads/LeadsApi";
import { FormLength } from "./Forms/FormApi";
import { LadingLength } from "./LandingPage/LandingApi";
import { InvestorLength } from "./Investor/InvestorApi";
import { UserLength } from "./UserManagement/UserManagementApi";
import { UserTrackingLength } from "./UserTracking/UserTrackingLength";
import { ApiContext } from "./apiContext";

export default function Sidebar({ permission, role }) {
  const [filteredModules, setFilteredModules] = useState([]);
  const { data } = useContext(ApiContext);

  // Compute 1-week stats
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  oneWeekAgo.setHours(0, 0, 0, 0); // start of the day 7 days ago (e.g. July 17 00:00:00)
  
  const twoWeeksAgo = new Date();
  twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
  twoWeeksAgo.setHours(0, 0, 0, 0); // start of the day 14 days ago (e.g. July 10 00:00:00)

  const leadsList = data?.leads || [];
  const blogsList = data?.blog || [];

  // Filter leads in the last 1 week
  const lastWeekLeads = leadsList.filter(lead => lead.dateTime && new Date(lead.dateTime) >= oneWeekAgo);
  const previousWeekLeads = leadsList.filter(lead => {
    if (!lead.dateTime) return false;
    const d = new Date(lead.dateTime);
    return d >= twoWeeksAgo && d < oneWeekAgo;
  });

  const leadsChange = previousWeekLeads.length 
    ? Math.round(((lastWeekLeads.length - previousWeekLeads.length) / previousWeekLeads.length) * 100) 
    : lastWeekLeads.length * 100;

  // Split last week ham vs spam
  const lastWeekHam = lastWeekLeads.filter(lead => lead.classification === "ham" || !lead.classification).length;
  const lastWeekSpam = lastWeekLeads.filter(lead => lead.classification === "spam").length;

  // New blogs live in last 1 week
  const lastWeekBlogs = blogsList.filter(blogStr => {
    try {
      const b = JSON.parse(blogStr);
      const date = b.updatedDate ? new Date(b.updatedDate) : new Date(b.createdDate);
      return date >= oneWeekAgo;
    } catch {
      return false;
    }
  }).length;

  useEffect(() =>{   
    getUserData()
  },[role])
  function getUserData() {
    if (role === "user") {
      const allowedModules = permission.map((perm) =>
        perm.module.toLowerCase()
      );

      const filtered = ViewModels.filter((item) =>
        allowedModules.includes(item.State?.toLowerCase())
      );
      setFilteredModules(filtered);
    } else {
      setFilteredModules(ViewModels);
    }
  }
  return (
    <>
      <div className="row">
        {filteredModules.map((item, index) => {
          if (!item.Visible) return null; 

          return (
            <div className="menu-item col-12 col-sm-6 col-md-4 col-lg-3" key={item.Href}>
              <NavLink
                to={item.Href}
                className="link-data"
                active="active"
                key={index}
              >
                <div className="link-icon">
                  <span>{item.Icon}</span>
                </div>
                <div className="text-box">
                  <h4 className="item-length">
                    {(() => {
                      switch (item.State) {
                        case "blog":
                          return <BlogLength />;
                        case "casestudies":
                          return <CaseStudiesLength />;
                        case "career":
                          return <CareerLength />;
                        case "event":
                          return <EventLength />;
                        case "award":
                          return <AwardLength />;
                        case "testimonials":
                          return <TestiLength />;
                        case "urllist":
                          return <UrlLength />;
                        case "video":
                          return <VideoLength />;
                        case "videos":
                          return <VideosLength />;
                        case "ebooks":
                          return <EbookLength />;
                        case "ads":
                          return <AdsLength />;
                        case "pagevideo":
                          return <PageVideoLength />;
                        case "faqs":
                          return <FaqsLength />;
                        case "glossary":
                          return <GlossaryLength />;
                        case "ipmapping":
                          return <InterestedproductLength />;
                        case "webinar":
                          return <WebinarLength />;
                        case "metaTag":
                          return <MetaTagLength />;
                        case "email":
                          return <EmailLength />;
                        case "leads":
                          return <LeadLength />;
                        case "cta":
                        case "customization":
                          return <FormLength />;
                        case "landingPage":
                          return <LadingLength />;
                        case "investor":
                          return <InvestorLength />;
                        case "userManagement" :
                          return <UserLength /> ;
                        case "usertracking" :
                          return <UserTrackingLength /> ;
                        default:
                          return null;
                      }
                    })()}
                  </h4>
                  <p className="link-text">{item.Title}</p>
                </div>
              </NavLink>
            </div>
          );
        })}
      </div>

    </>
  );
}
